module.exports = __webpack_public_path__ + "static/media/arrow-from-right.9d8983a0.svg";